// Shared pieces of the Domain 07 management incidents (SNMP traps, syslog, NTP): the Iloilo NOC
// as operated after Mission 07, functional probes that create a fresh event on a COPY of the lab
// and read what SRV-MON receives, and the "rest of monitoring unchanged" check.
import { clone } from '../engine/net/model.js';
import { logEvent, monitoringView, ntpState } from '../engine/net/services.js';
import { nocLayout, MON } from '../domains/d07/topologies.js';
import { siteUp } from '../domains/d07/helpers.js';

export { nocLayout };
/** What SRV-MON receives after `id` generates `text` now (on a copy; the lab is not touched). */
export function receivedAfter(rt, id, text) {
  const n = clone(rt.net);
  logEvent(n, id, text);
  return monitoringView(n, MON.ip, MON.community);
}
/** A fresh configuration-change message from R-x reaches SRV-MON as syslog. */
export const syslogArrives = (rt, id) => receivedAfter(rt, id, `%SYS-5-CONFIG_I: Configured from console by audit-probe on vty0 (10.70.10.11)`).syslog.some((e) => e.dev === rt.net.devices[id].hostname && /audit-probe/.test(e.text));
/** A fresh link-down on R-x raises a linkDown trap at SRV-MON. */
export const trapArrives = (rt, id) => receivedAfter(rt, id, '%LINK-3-UPDOWN: Interface GigabitEthernet0/1, changed state to down').traps.some((t) => t.dev === rt.net.devices[id].hostname && /linkDown GigabitEthernet0\/1/.test(t.text));
/** Polling, syslog destination and the site itself still work for both routers. */
export function pollingAndSite(rt) {
  const v = monitoringView(clone(rt.net), MON.ip, MON.community);
  return ['R1', 'R2'].every((id) => v.polled[id]?.ok && (rt.net.devices[id].logging?.hosts || []).includes(MON.ip)) && siteUp(rt);
}
/** Both routers synchronised (any valid chain); used where NTP is not the subject. */
export const clocksSynced = (rt) => { const s = ntpState(clone(rt.net)); return s.R1?.synced && s.R2?.synced; };
/** Evidence: the NMS console was refreshed. */
export const nmsLooked = (ev) => ev.type === 'action' && ev.name === 'nms-refresh';
